window.addEventListener('load', function() {
//※js記載 フッターのscriptが読み込まれてから起動
	jQuery(function($){
		$(".plus_toggle").on("click", function() {
			$(this).toggleClass("opened");
			$(this).next().slideToggle();
		});
	});
});


document.addEventListener('DOMContentLoaded', function() {
  // 複数の対象要素を取得
  const targets = document.querySelectorAll('.product_title_line .rich-text__subheading.h3');
  if (!targets.length) return; // 要素が見つからなければ処理終了

  // IntersectionObserver を作成
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // 要素がビューポートに入ったら
      if (entry.isIntersecting) {
        // 500ms後にクラスを追加
        setTimeout(() => {
          entry.target.classList.add('underline-animate');
        }, 500);
        // アニメーション発火後、その要素の監視を解除
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // 要素の10%が見えたら判定（適宜調整可）
  });

  // すべての要素を監視開始
  targets.forEach(target => {
    observer.observe(target);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // 複数の対象要素を取得
  const targets = document.querySelectorAll('.template-product .product__title h1');
  if (!targets.length) return; // 要素が見つからなければ処理終了

  // IntersectionObserver を作成
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // 要素がビューポートに入ったら
      if (entry.isIntersecting) {
        // 500ms後にクラスを追加
        setTimeout(() => {
          entry.target.classList.add('underline-animate');
        }, 500);
        // アニメーション発火後、その要素の監視を解除
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // 要素の10%が見えたら判定（適宜調整可）
  });

  // すべての要素を監視開始
  targets.forEach(target => {
    observer.observe(target);
  });
});


// アンカーリンクスクロール
document.addEventListener("DOMContentLoaded", function () {
    var headerHeight = 0;
    var links = document.querySelectorAll('a[href^="#"]');

    links.forEach(function (link) {
        link.addEventListener("click", function (e) {
            var href = this.getAttribute("href");

            // href が "#" または "" の場合は何もしない
            if (href === "#" || href === "") return;

            var target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                var position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

                window.scrollTo({
                    top: position,
                    behavior: "smooth"
                });
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const currentHost = location.hostname;

  // 対象セレクターをまとめて取得
  const links = document.querySelectorAll('a.dock__item, .footer_base_link a');

  links.forEach(link => {
    const href = link.getAttribute('href');

    // hrefが存在していて、外部リンクである場合のみ処理
    if (href && href.startsWith('http') && !href.includes(currentHost)) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer'); // セキュリティ対策も合わせて
    }
  });
});
